module.exports = __webpack_public_path__ + "img/about-main-2.97ae63a8.jpg";